<template>
  <div class="belt flex flex-wrap" :class="'temp' + index">
    <slot name="swiper" />
    <div
      class="belt-wrapper"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    >
      <template v-for="(v, i) in textList">
        <div
          class="text-wrapper flex"
          :class="'tw' + (i + 1)"
          v-if="v.show"
          :key="i"
        >
          <div
            class="title"
            :style="{
              color: v.titleColor,
              fontSize: v.titleFontSize + 'px',
              fontWeight: v.titleFontWeight
            }"
          >
            {{ v.title }}
          </div>
          <div
            class="content"
            :style="{
              color: v.contentColor,
              fontSize: v.contentFontSize + 'px',
              fontWeight: v.contentFontWeight
            }"
          >
            <span v-if="v.contentType === 'timeRange'">08-08至08-08</span>
            <span v-if="v.contentType === 'countDown'">8天8分08秒</span>
            <span v-if="v.contentType === 'discountPrice'">￥189.99</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backgroundImage: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 1
    },
    textList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formatDate: "",
      days: 0,
      hours: "00",
      minutes: "00",
      seconds: "00",
      timer: "",
      timeUp: false
    };
  },
  watch: {
    applyDate: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          // this.init(this.applyDate[1]);
          const startDate = val[0].split(" ")[0];
          const endDate = val[1].split(" ")[0];
          const startYear = startDate.split("-")[0];
          const endYear = endDate.split("-")[0];
          if (startYear === endYear) {
            this.formatDate =
              startDate.substring(5) + "至" + endDate.substring(5);
          } else {
            this.formatDate = startDate + "至" + endDate;
          }
        }
      }
    }
  },
  created() {},
  methods: {
    init(val) {
      if (val) {
        this.setTime(val);
        this.timer = setInterval(() => {
          this.setTime(val);
        }, 1000);
      }
    },
    setTime(val) {
      const now = new Date().getTime();
      const time = val - now;
      if (time <= 0) {
        this.timeUp = true;
        clearInterval(this.timer);
        this.$emit("timeUp", true);
        return;
      }
      const { days, hours, minutes, seconds } = this.formatDuring(time);
      this.days = days;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
    },
    formatDuring(mss) {
      const days = this.formatNumber(parseInt(mss / (1000 * 60 * 60 * 24)));
      const hours = this.formatNumber(
        parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      );
      const minutes = this.formatNumber(
        parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
      );
      const seconds = this.formatNumber(parseInt((mss % (1000 * 60)) / 1000));
      return {
        days,
        hours,
        minutes,
        seconds
      };
    },
    formatNumber(n) {
      const str = n.toString();
      return str[1] ? str : `0${str}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.belt {
  position: relative;
  .belt-wrapper {
    background-size: 100% 100%;
    width: 100%;
  }
  &.temp1 {
    .belt-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    .text-wrapper {
      position: absolute;
      &.tw1 {
        bottom: 48px;
        left: 40px;
      }
      &.tw2 {
        bottom: 40px;
        right: 12px;
      }
      &.tw3 {
        bottom: 10px;
        left: 0px;
      }
      &.tw4 {
        bottom: 8px;
        right: 10px;
      }
    }
  }

  &.temp2 {
    .belt-wrapper {
      position: relative;
      height: 78px;
      .text-wrapper {
        position: absolute;
        &.tw1 {
          top: 8px;
          left: 10px;
          transform: skew(-10deg);
        }
        &.tw2 {
          top: 15px;
          right: 12px;
          transform: skew(-10deg);
        }
        &.tw3 {
          bottom: 6px;
          left: 12px;
          transform: skew(-10deg);
        }
        &.tw4 {
          bottom: 12px;
          right: 10px;
        }
      }
    }
  }
}
</style>
